import { useHasPermission } from '@hooks';
import { ErrorPage } from '@pages';
import { Permission } from '@common/utils/admin_permissions';
import { PropsWithChildren } from 'react';

interface PermissionMiddlewareProps {
  permissions: Permission[];
}

export function PermissionMiddleware({ children, permissions }: PropsWithChildren<PermissionMiddlewareProps>) {
  const hasRoutePermission = useHasPermission(permissions);

  if (hasRoutePermission) {
    return <>{children}</>;
  }

  return <ErrorPage errorCode={403} />;
}
